var AddedMatchHighlightsModifier = /** @class */ (function () {
    function AddedMatchHighlightsModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    AddedMatchHighlightsModifier.prototype.modify = function (content) {
        if (content.event_highlights === undefined || content.event_highlights.add === undefined) {
            return;
        }
        var highlights = content.event_highlights.add;
        for (var i = 0; i < highlights.length; i++) {
            var highlight = highlights[i];
            highlights[i] = {
                id: highlight.id,
                name: highlight.hn,
                priority: highlight.hp
            };
        }
    };
    return AddedMatchHighlightsModifier;
}());
export default AddedMatchHighlightsModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/AddedMatchHighlightsModifier.js